import { Component, OnInit, forwardRef } from '@angular/core';
import { NavController, NavParams, ModalController, IonicModule } from '@ionic/angular';
import { UserProvider } from 'src/app/services/user/user';
import { Browser } from '@capacitor/browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';


import { TranslateModule } from '@ngx-translate/core';
import { ImagePipe } from 'src/app/pipes/image/image';
import { PhonePipe } from 'src/app/pipes/phone/phone';

@Component({
  selector: 'app-acompanhamento-part-det',
  templateUrl: './acompanhamento-part-det.page.html',
  styleUrls: ['./acompanhamento-part-det.page.scss'], 
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    PhonePipe
  ],
})
export class AcompanhamentoPartDetPage implements OnInit {

  pessoa: any = {};
  ddi: string = "55";
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public userProvider: UserProvider,
    public modalCtrl: ModalController,
  ) {
    this.pessoa = this.navParams.get('pessoa');

    this.userProvider.getDados().then(res => {
      this.ddi = res.config.ddi;
    });
  }

  ngOnInit() {
  }

  abrirLink = async () => {
    await Browser.open({ url: 'https://api.whatsapp.com/send?phone=' + this.ddi + this.pessoa.telCelular });
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
